/**
 * What the Nearby Drivers tab asks for, and when it asks.
 *
 * Together in one file because they are read together: the radii are the question the operator poses, the
 * settle times are how long the tab waits before posing it, and the two settle times only mean anything in
 * relation to each other. Inside the component the pair was a long comment in the middle of 700 lines of
 * rendering, which is where a number goes to be changed without its sibling.
 *
 * This is the same reason main-service keeps `box-truck-loads/limits.ts`: "what does this surface cap?" is
 * a question about the SET, and scattered one-per-callsite it can only be answered by reading everything.
 */

/** Selectable search radii (miles). Defaults to 150 so an operator sees a useful spread up front; they can
 *  narrow or widen from the dropdown. */
export const NEARBY_RADIUS_OPTIONS = [50, 100, 150, 200, 250]
export const NEARBY_DEFAULT_RADIUS_MI = 150
export const NEARBY_MOBILE_RADIUS_OPTIONS = NEARBY_RADIUS_OPTIONS.map((radius) => ({ label: `${radius} mi`, value: String(radius) }))

/** Settle time for a radius the operator is still changing (the drawer's form feeds it keystroke by
 *  keystroke). Deliberately NOT applied to the first search for a new origin — see the tab's fetch effect. */
export const NEARBY_RADIUS_DEBOUNCE_MS = 350

/**
 * Settle time when the only thing that changed is this load's BID set.
 *
 * Bids arrive over the socket, and each one changes the forced-in `include` set — so an actively-bid load
 * refetched the whole page per bid, for the one row the bid added. Nothing the operator did asked for that,
 * so it can wait: bids within a few seconds of each other collapse into one refetch instead of one each.
 *
 * Longer than the radius debounce because the two are different questions. A radius is the operator turning
 * a dial and watching the list answer; a bid is news arriving on its own, and a second or two late is news
 * all the same. That difference is the reason both live here rather than one each beside its own timer.
 */
export const NEARBY_BID_REFRESH_DEBOUNCE_MS = 2_000
